import { render, staticRenderFns } from "./AverageTicket.vue?vue&type=template&id=30473f0c&scoped=true"
import script from "./AverageTicket.vue?vue&type=script&lang=js"
export * from "./AverageTicket.vue?vue&type=script&lang=js"
import style0 from "./AverageTicket.vue?vue&type=style&index=0&id=30473f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30473f0c",
  null
  
)

export default component.exports